import { Flex, Text } from '@sendoutcards/quantum-design-ui'
import React from 'react'
import { Rating } from './Rating'

type CustomerReviewProps = {
  title: string
  rating: number
  review: string
}

export const CustomerReview: React.FC<CustomerReviewProps> = ({
  title,
  rating,
  review,
}) => {
  return (
    <Flex flexDirection="column" width="100%" rowGap="x1_5">
      <Text
        type="body"
        content={title}
        style={{
          fontFamily: 'Montserrat',
          fontSize: '1.125rem',
          fontWeight: 700,
          color: '#6B7280',
        }}
      />
      <Rating rating={rating} />
      <Text
        type="body"
        content={review}
        style={{
          fontFamily: 'Montserrat',
          fontSize: '1rem',
          color: '#6B7280',
          fontStyle: 'italic',
        }}
      />
    </Flex>
  )
}
